import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHomeState } from './types';
import { IRequestFailed } from '@app/types';
import { RequestStatus } from '@app/constants';

const initialState: IHomeState = {
  recommendations: {},
  newRecipes: {},
};

const slice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    getRecommendations(state) {
      state.recommendations.status = RequestStatus.RUNNING;
    },
    setRecommendationsSuccess(state, action) {
      state.recommendations.status = RequestStatus.SUCCESS;
      state.recommendations.data = action.payload;
    },
    setRecommendationsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.recommendations.status = RequestStatus.ERROR;
      state.recommendations.error = action.payload;
    },
    getNewRecipes(state) {
      state.newRecipes.status = RequestStatus.RUNNING;
    },
    setNewRecipesSuccess(state, action) {
      state.newRecipes.status = RequestStatus.SUCCESS;
      state.newRecipes.data = action.payload;
    },
    setNewRecipesFailed(state, action: PayloadAction<IRequestFailed>) {
      state.newRecipes.status = RequestStatus.ERROR;
      state.newRecipes.error = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  getRecommendations,
  setRecommendationsSuccess,
  setRecommendationsFailed,
  getNewRecipes,
  setNewRecipesSuccess,
  setNewRecipesFailed,
} = slice.actions;
